import { Component, EventEmitter, Input, Output } from "@angular/core";

import { FieldType } from "./constants";
import { treeAnimations } from "./json-tree-animations";

@Component({
  selector: "ta-json-root-node",
  templateUrl: "./json-root-node.template.html",
  animations: treeAnimations
})
export class JsonRootNodeComponent {
  @Input()
  canBeDeleted: boolean;

  @Input()
  label: string;

  @Input()
  isLastChild: boolean;

  @Input()
  animate: boolean = false;

  @Input()
  fieldType: FieldType.Array | FieldType.Object;

  @Input()
  collapsed = true;

  @Output()
  clickDelete = new EventEmitter();

  @Output()
  clickAddChild = new EventEmitter();

  @Output()
  clickToggleCollapsed = new EventEmitter();

  hovered = false;

  get icon(): string {
    const contents = this.collapsed ? "..." : "";
    return this.fieldType === FieldType.Object
      ? `{${contents}}`
      : `[${contents}]`;
  }

  get brackets(): [string, string] {
    return this.fieldType === FieldType.Object
      ? ["{", "}"]
      : ["[", "]"];
  }
}
